import React from "react";
import { useI18n } from "@/i18n/I18nProvider";

const LOGO_URL = "/atlas-logo.png";

export default function AtlasFooter() {
  const { t } = useI18n();
  return (
    <footer data-testid="atlas-footer" className="bg-slate-950 text-slate-300">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 md:gap-10">
          <div className="md:col-span-2">
            <img
              src="/atlas-logo-white.png"
              alt="ATLAS Industrial"
              className="h-14 w-auto object-contain select-none"
              draggable={false}
            />
            <p className="mt-4 text-slate-400 max-w-md text-sm leading-relaxed">
              {t("footer.tagline")}
            </p>
          </div>

          <FooterCol
            title={t("footer.colProducto")}
            links={[
              { label: t("nav.soluciones"), href: "#soluciones" },
              { label: t("nav.sectores"), href: "#sectores" },
              { label: t("nav.casos"), href: "#casos-exito" },
              { label: t("nav.recursos"), href: "#testimonios" },
            ]}
          />
          <FooterCol
            title={t("footer2.colRecursos")}
            links={[
              { label: t("footer2.linkDocs"), href: "/docs", testid: "footer-link-docs" },
              { label: t("footer2.linkSupport"), href: "mailto:contacto@atlas-system.net", testid: "footer-link-support" },
              { label: t("footer2.linkStatus"), href: "#", testid: "footer-link-status" },
              { label: "Acceso Admin", href: "/admin/leads", testid: "footer-link-admin" },
            ]}
          />
          <FooterCol
            title={t("footer.colEmpresa")}
            links={[
              { label: t("footer.linkContacto"), href: "#" },
              { label: t("footer.linkSoporte"), href: "mailto:soporte@atlas-system.net" },
              { label: t("footer.linkPrivacy"), href: "#" },
              { label: t("footer.linkTerms"), href: "#" },
            ]}
          />
        </div>

        <div className="mt-10 pt-6 border-t border-slate-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p
            data-testid="footer-copyright"
            className="text-sm text-slate-400 flex items-center gap-2"
          >
            {t("footer.copyright")}
            <ArgFlag />
          </p>
          <p className="text-xs text-slate-500">{t("footer.rights")}</p>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <h4 className="font-display font-bold text-white text-sm uppercase tracking-wider">
        {title}
      </h4>
      <ul className="mt-4 space-y-2">
        {links.map((l) => (
          <li key={l.label}>
            <a
              href={l.href || "#"}
              data-testid={l.testid}
              className="text-sm text-slate-400 hover:text-white transition-colors"
            >
              {l.label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

function ArgFlag() {
  return (
    <span
      className="inline-flex items-center rounded-sm overflow-hidden ring-1 ring-black/20"
      aria-label="Bandera de Argentina"
      role="img"
      data-testid="footer-arg-flag"
    >
      <svg
        width="22"
        height="14"
        viewBox="0 0 30 20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="30" height="20" fill="#74ACDF" />
        <rect y="6.67" width="30" height="6.66" fill="#FFFFFF" />
        <circle
          cx="15"
          cy="10"
          r="1.8"
          fill="#F6B40E"
          stroke="#85340A"
          strokeWidth="0.3"
        />
      </svg>
    </span>
  );
}
